import { fg } from '@atlaskit/platform-feature-flags/fg';

export const shouldRetry = (error: unknown): boolean => {
	if (fg('platform_relay_fetch_guard_non_object_retry_errors')) {
		if (typeof error !== 'object' || error === null) {
			return false;
		}
	}

	const fetchError = error as Error;
	if ('statusCode' in fetchError && typeof fetchError.statusCode === 'number') {
		return [502, 503, 504].includes(fetchError.statusCode);
	}
	return false;
};
